import { Dispatch } from 'redux';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { Logger } from '../../devices/logger/interface/Logger';
import { Scanner } from '../../devices/scanners/interface/Scanner';
import { Locker } from '../../devices/locker/interface/Locker';

export const setLoggerAction = (logger: Logger) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.SET_LOGGER, payload: logger });
  };
};
export const setScannerAction = (scanner: Scanner) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.SET_SCANNER, payload: scanner });
  };
};
export const setLockerAction = (locker: Locker) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.SET_LOCKER, payload: locker });
  };
};
export const updateSettingUpScanners = (settingUpScanners: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_SETTING_UP_SCANNERS,
      payload: settingUpScanners,
    });
  };
};
export const UpdateSettingUpLocker = (settingUpLocker: boolean) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_SETTING_UP_LOCKER,
      payload: settingUpLocker,
    });
  };
};
export const resetDevices = () => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({ type: ActionType.RESET_DEVICES });
  };
};
